export { EventBus };

var EventBus = new Vue();
